import { appVersion } from "./version";

/**
 * Inconspicuous build-version marker pinned to the bottom-right corner. Hover
 * shows the commit and build time. Kept tiny and muted so it never competes with
 * the UI, but is always available for support/debugging ("which build is this?").
 */
export function VersionBadge() {
  return (
    <span
      data-testid="version-badge"
      title={`commit ${appVersion.commit} · built ${appVersion.buildTime}`}
      className="fixed bottom-1 right-2 z-50 select-none font-mono text-[10px] leading-none text-slate-400/70"
    >
      v{appVersion.version}
    </span>
  );
}
